import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Calendar, Clock } from 'lucide-react';
import { Card } from '../ui/Card';
export function ProgressCard() {
  return <Card className="bg-gradient-to-br from-[var(--secondary)] to-gray-800 text-white border-none relative overflow-hidden" data-id="element-170">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-white opacity-5 rounded-full blur-2xl" data-id="element-171"></div>
      <div className="absolute bottom-0 left-0 -mb-4 -ml-4 w-32 h-32 bg-[var(--primary)] opacity-10 rounded-full blur-3xl" data-id="element-172"></div>

      <div className="relative z-10" data-id="element-173">
        <div className="flex justify-between items-start mb-6" data-id="element-174">
          <div data-id="element-175">
            <h3 className="text-gray-300 text-sm font-medium mb-1" data-id="element-176">
              Status Atual
            </h3>
            <div className="flex items-center gap-2" data-id="element-177">
              <span className="text-2xl font-bold" data-id="element-178">Em Evolução</span>
              <span className="bg-[var(--success)] text-white text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-179">
                +12%
              </span>
            </div>
          </div>
          <div className="h-10 w-10 rounded-full border-2 border-[var(--primary)] p-0.5" data-id="element-180">
            <img src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" alt="User" className="w-full h-full rounded-full object-cover" data-id="element-181" />
          </div>
        </div>

        <div className="space-y-4" data-id="element-182">
          <div data-id="element-183">
            <div className="flex justify-between text-xs text-gray-400 mb-1" data-id="element-184">
              <span data-id="element-185">Meta Semanal</span>
              <span data-id="element-186">3/4 Treinos</span>
            </div>
            <div className="h-2 bg-gray-700 rounded-full overflow-hidden" data-id="element-187">
              <motion.div initial={{
              width: 0
            }} animate={{
              width: '75%'
            }} transition={{
              duration: 1,
              ease: 'easeOut'
            }} className="h-full bg-[var(--primary)] rounded-full" data-id="element-188" />
            </div>
          </div>

          <div className="grid grid-cols-3 gap-2 pt-2" data-id="element-189">
            <div className="text-center p-2 bg-white/5 rounded-lg backdrop-blur-sm" data-id="element-190">
              <Calendar size={16} className="mx-auto mb-1 text-gray-400" data-id="element-191" />
              <span className="block text-lg font-bold" data-id="element-192">12</span>
              <span className="text-[10px] text-gray-400" data-id="element-193">Treinos</span>
            </div>
            <div className="text-center p-2 bg-white/5 rounded-lg backdrop-blur-sm" data-id="element-194">
              <Clock size={16} className="mx-auto mb-1 text-gray-400" data-id="element-195" />
              <span className="block text-lg font-bold" data-id="element-196">14h</span>
              <span className="text-[10px] text-gray-400" data-id="element-197">Tempo</span>
            </div>
            <div className="text-center p-2 bg-white/5 rounded-lg backdrop-blur-sm" data-id="element-198">
              <TrendingUp size={16} className="mx-auto mb-1 text-gray-400" data-id="element-199" />
              <span className="block text-lg font-bold" data-id="element-200">Top 10%</span>
              <span className="text-[10px] text-gray-400" data-id="element-201">Ranking</span>
            </div>
          </div>
        </div>
      </div>
    </Card>;
}